import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCTA() {
  return <section className="bg-[#0B0B1A] py-20 px-4 text-center border-t-4 border-[#00FF66]" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-8 leading-tight" data-id="element-51">
          Internet no es peligroso…
          <br data-id="element-52" />
          <span className="text-[#FF3333]" data-id="element-53">
            Usarlo sin saber protegerte sí.
          </span>
        </h2>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 mb-10 inline-block text-left" data-id="element-54">
          <p className="text-2xl font-bold text-[#00D4FF] mb-6 text-center" data-id="element-55">
            Empieza hoy a proteger:
          </p>
          <ul className="space-y-4 text-xl md:text-2xl text-white font-medium" data-id="element-56">
            <li className="flex items-center gap-3" data-id="element-57">
              <span data-id="element-58">🔐</span> tus cuentas
            </li>
            <li className="flex items-center gap-3" data-id="element-59">
              <span data-id="element-60">🔐</span> tu información
            </li>
            <li className="flex items-center gap-3" data-id="element-61">
              <span data-id="element-62">🔐</span> tu negocio
            </li>
          </ul>
        </div>

        <div className="text-center" data-id="element-63">
          <p className="text-4xl mb-6 animate-bounce" data-id="element-64">👇</p>
          <CtaButton text="Accede ahora a la colección de Ciberseguridad" className="w-full md:w-auto md:px-10 md:py-6 md:text-2xl" data-id="element-65" />
        </div>
      </div>
    </section>;
}